import { render, staticRenderFns } from "./PdProfileSection.vue?vue&type=template&id=58f1119c&scoped=true&"
import script from "./PdProfileSection.vue?vue&type=script&lang=js&"
export * from "./PdProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./PdProfileSection.vue?vue&type=style&index=0&id=58f1119c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1119c",
  null
  
)

export default component.exports